import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from 'semantic-ui-react';
import { Form} from '@weezevent/nacre';
import PropTypes from 'prop-types';
import {CountrySelectorLabel} from '../../../nacre/components/countrySelector';
import countries from 'i18n-iso-countries';


export default function StaticAddressForm({address={}, onChange, errors={}}){
    const { t, i18n } = useTranslation();

    const lang = React.useMemo(()=> {
        return i18n.language.split('-')[0]
    }, [i18n])

    const getCountryLabel = React.useCallback((code) => {
        if (!lang || !code) {
            return '';
        }

        return countries.getName(code, lang, {select: "official"})
    }, [lang]);

    const onChangeAddress = React.useCallback((key, value)=> {

        let new_address = {...{
            name: "",
            address1: "",
            address2: "",
            city: "",
            country: "",
            state: "",
            zip_code: ""
        }, ...address };
        new_address[key] = value;

        let fullAddress =
            (new_address.address1 ? new_address.address1 + ' ' : '') +
            (new_address.zip_code ? new_address.zip_code + ' ' : '') +
            (new_address.city ? new_address.city + ' ' : '') +
            (getCountryLabel(new_address.country));

        onChange({full_address:fullAddress, address: new_address});
    }, [address, onChange, getCountryLabel]);

    return (
        <>
            <Form.Field error={errors['name'] ? true : false}>
                <Form.Label label={t("ticket.event.place")}/>
                <Form.Input autocomplete="none" required={errors['name'] ? true : false} onChange={event => onChangeAddress('name', event.target.value)} value={address?.name} />
                <Form.FieldErrors errors={errors['name'] ? [t(errors['name'])] : ['']} />
            </Form.Field>

            <Form.Field error={errors['address1'] ? true : false}>
                <Form.Label label={t("ticket.event.address")}/>
                <Form.Input autocomplete="none" required={errors['address1'] ? true : false} onChange={event => onChangeAddress('address1', event.target.value)} value={address?.address1} />
                <Form.FieldErrors errors={errors['address1'] ? [t(errors['address1'])] : ['']} />
            </Form.Field>

            <Form.Field>
                <Form.Label label={t("ticket.event.state")}/>
                <Form.Input autocomplete="none" onChange={event => onChangeAddress('state', event.target.value)} value={address?.state} />
            </Form.Field>

            <Grid>
                <Grid.Row columns={2}>
                    <Grid.Column >
                        <Form.Field>
                            <Form.Label label={t("ticket.event.postcode")}/>
                            <Form.Input autocomplete="none" onChange={event => onChangeAddress('zip_code', event.target.value)} value={address?.zip_code} maxLength={10} />
                        </Form.Field>
                    </Grid.Column>
                    <Grid.Column >
                        <Form.Field>
                            <Form.Label label={t("ticket.event.city")}/>
                            <Form.Input autocomplete="none" onChange={event => onChangeAddress('city', event.target.value)} value={address?.city} />
                        </Form.Field>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <CountrySelectorLabel label={t('ticket.event.country')} placeholder={t('ticket.event.country_placeholder')} value={address?.country} onChange={(value)=> onChangeAddress('country', value)} />
        </>
    );
}

StaticAddressForm.propTypes = {
    address: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.shape
};